import axios from 'axios'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import config from '../../../config'

const Signup = () => {
  const [show, setShow] = useState(false)
  const handleClick = () => setShow(!show)
  //   const toast = useToast()
  const navigate = useNavigate()

  const [name, setName] = useState()
  const [email, setEmail] = useState()
  const [showFirstIcon, setShowFirstIcon] = useState(true)
  const [phone, setPhone] = useState()
  const [confirmpassword, setConfirmpassword] = useState()
  const [password, setPassword] = useState()
  const [pic, setPic] = useState()
  const [picLoading, setPicLoading] = useState(false)

  const toggleIcon = () => {
    setShowFirstIcon(prev => !prev)
  }

  const submitHandler = async () => {
    setPicLoading(true)
    // if (!name || !email || !password || !confirmpassword) {
    //   toast({
    //     title: "Please Fill all the Feilds",
    //     status: "warning",
    //     duration: 5000,
    //     isClosable: true,
    //     position: "bottom",
    //   });
    //   setPicLoading(false);
    //   return;
    // }
    // if (password !== confirmpassword) {
    //   toast({
    //     title: "Passwords Do Not Match",
    //     status: "warning",
    //     duration: 5000,
    //     isClosable: true,
    //     position: "bottom",
    //   });
    //   return;
    // }
    console.log(name, email, password, pic)
    try {
      const head = {
        headers: {
          'Content-type': 'application/json'
        }
      }
      const { data } = await axios.post(
        `${config.devapi}user`,
        {
          name,
          email,
          password,
          phone,
          pic
        },
        head
      )
      console.log(data)
      //   toast({
      //     title: 'Registration Successful',
      //     status: 'success',
      //     duration: 5000,
      //     isClosable: true,
      //     position: 'bottom'
      //   })
      localStorage.setItem('userInfo', JSON.stringify(data))
      setPicLoading(false)
      navigate('/dashboard')
    } catch (error) {
      //   toast({
      //     title: 'Error Occured!',
      //     description: error.response.data.message,
      //     status: 'error',
      //     duration: 5000,
      //     isClosable: true,
      //     position: 'bottom'
      //   })
      setPicLoading(false)
    }
  }

  return (
    <>
      <section>
        {/* <div className="mx-auto px-4 w-100" style={{ maxWidth: '18rem' }}> */}
        <div className="fileds" style={{ paddingTop: '20px' }}>
          <div className="row d-flex flex-column">
            <label
              className="col-6 text-muted w-100"
              style={{ fontSize: '14px' }}
            >
              &nbsp;Name
              <span style={{ color: 'red' }}>&nbsp;&nbsp;*</span>
              <input
                className="mt-2"
                name="Name"
                type="text"
                placeholder="Enter Name"
                onChange={e => setName(e.target.value)}
                // onChange={handleChange}
                // value={values.firstName}
              />
              {/* {errors.firstName && touched.firstName && (
              <div className="d-block invalid-tooltip hel-error">
                {errors.firstName}
              </div>
            )} */}
            </label>
            <label
              className="col-6 text-muted w-100 mt-2"
              style={{ fontSize: '14px' }}
            >
              &nbsp;Email
              <span style={{ color: 'red' }}>&nbsp;&nbsp;*</span>
              <input
                className="mt-2"
                name="email"
                type="email"
                placeholder="Enter Email"
                onChange={e => setEmail(e.target.value)}
                // onChange={handleChange}
                // value={values.firstName}
              />
              {/* {errors.firstName && touched.firstName && (
              <div className="d-block invalid-tooltip hel-error">
                {errors.firstName}
              </div>
            )} */}
            </label>
            <label
              className="col-6 text-muted w-100 mt-2"
              style={{ fontSize: '14px' }}
            >
              &nbsp;Phone
              <span style={{ color: 'red' }}>&nbsp;&nbsp;*</span>
              <input
                className="mt-2"
                type="tel"
                placeholder="Enter Mobile Number"
                maxLength={10}
                pattern="[0-9]*"
                inputMode="numeric"
                onChange={e => setPhone(`91${e.target.value}`)}
                // value={phoneNumber}
                // onChange={handlePhoneNumberChange}
              />
              {/* {errors.firstName && touched.firstName && (
              <div className="d-block invalid-tooltip hel-error">
                {errors.firstName}
              </div>
            )} */}
            </label>

            <label
              className="col-6 text-muted w-100 mt-2"
              style={{ fontSize: '14px' }}
            >
              &nbsp;Password
              <span style={{ color: 'red' }}>&nbsp;&nbsp;*</span>
              <div style={{ position: 'relative' }}>
                <input
                  type={!showFirstIcon ? 'text' : 'password'}
                  className="mt-2"
                  placeholder="Password"
                  onChange={e => setPassword(e.target.value)}
                />
                <label className="hideandshow mt-2" onClick={toggleIcon}>
                  {showFirstIcon ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                      className="w-4"
                      style={{ width: '1rem' }}
                    >
                      <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"></path>
                      <path
                        fillRule="evenodd"
                        d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                      className="w-4"
                      style={{ width: '1rem' }}
                    >
                      <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"></path>
                      <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"></path>
                      <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"></path>
                    </svg>
                  )}
                </label>
              </div>
            </label>
          </div>
        </div>
        <button
          className="pulls-right mt-3"
          type="button"
          onClick={submitHandler}
        >
          Sign up
        </button>
        {/* </div> */}
      </section>
    </>
  )
}

export default Signup
